import React from "react";
import "./styles.scss";

interface ISnappingContentProps {
    children: React.ReactNode;
}

export const SnappingContent: React.FunctionComponent<ISnappingContentProps> = ({
  children,
}) => (
  <>
    {React.Children.map(children, (child, index) => child && (
      <div className="snapping-section" key={index} id={`snapping-section-${index}`}>
        {child}
      </div>
    ))}
  </>
);

export default SnappingContent;
